// @flow
import {
  FETCH_FEEDBACK_FORM,
  FETCH_FEEDBACK_FORM_SUCCESS,
  FETCH_FEEDBACK_FORM_ERROR,
  SUBMIT_FEEDBACK,
  SUBMIT_FEEDBACK_SUCCESS,
  SUBMIT_FEEDBACK_ERROR,
} from "./types";
import type { Action } from "./types";

export const fetchFeedbackForm = (): Action => ({
  type: FETCH_FEEDBACK_FORM,
  // payload: {sessionId}
});

export const fetchFeedbackFormSuccess = (feedbackList: Array<any>): Action => ({
  type: FETCH_FEEDBACK_FORM_SUCCESS,
  payload: feedbackList,
});

export const fetchFeedbackFormError = (error: any): Action => ({
  type: FETCH_FEEDBACK_FORM_ERROR,
  payload: error
});

export const submitFeedback = (form: {[key: string]: string}, orderId: string, userDetails: {[key: string]: string}): Action => ({
  type: SUBMIT_FEEDBACK,
  payload: {form , orderId, userDetails}
});

export const submitFeedbackSuccess = (): Action => ({
  type: SUBMIT_FEEDBACK_SUCCESS,
});

export const submitFeedbackError = (error: any): Action => ({
  type: SUBMIT_FEEDBACK_ERROR,
  payload: error
});